import {
  Circle,
  ConnectWithoutContact,
  Delete,
  DeviceHubOutlined,
  DevicesOther,
  DeviceUnknown,
  Power,
  Refresh,
} from "@mui/icons-material";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import Device from "./Device";
import OnlineStatusTest from "./OnlineStatusTest";
import { useState } from "react";
import { ConnectionState } from "./states";
import { whiteGlassColor } from "./Colors";

export default function ConnectedDevice({
  connectionId,
  nickname,
  onClick,
  setDevices,
}: {
  connectionId: string;
  nickname: string;
  onClick: (connectionId: string) => void;
  setDevices: (devices: Device[]) => void;
}) {
  function deleteDevice() {
    const connectedDevices: Device[] = JSON.parse(
      localStorage.getItem("connectedDevices") || "[]"
    );
    const updatedDevices = connectedDevices.filter(
      (device) => device.connectionId !== connectionId
    );
    localStorage.setItem("connectedDevices", JSON.stringify(updatedDevices));
    setDevices(updatedDevices);
  }

  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const [connectionState, setConnectionState] = useState<ConnectionState>(ConnectionState.Connected);

  return (
    <Paper
      style={{
        width: "100%",
        height: "4em",
        display: "flex",
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center",
        padding: 1,
        justifyContent: "space-between",
        backgroundColor: "#FFFFFFFF",
        marginBottom: "0.5em",
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        {/* <OnlineStatusTest
          connectionId={connectionId}
          connectionStatus={connectionState}
          setConnectionStatus={setConnectionState}
        /> */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "0.5em",
          }}
        >
          <Typography variant="body1" fontWeight={"bold"}>
            {nickname}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ID: {connectionId}
          </Typography>
        </div>
        {connectionState === ConnectionState.Error ? <><Alert sx={{marginLeft: "0.5em"}} severity="error" >Unable to connect to server</Alert></> : null}
      </div>
      <div
        style={{ display: "flex", flexDirection: "row", marginRight: "0.2em" }}
      >
        <Tooltip title="Forget Device">
          <IconButton color="error" onClick={() => setShowDeleteDialog(true)}>
            <Delete />
          </IconButton>
        </Tooltip>

        {connectionState === ConnectionState.Connected ? (
          <Tooltip title="Connect to Device">
            <Button
              variant="outlined"
              color="primary"
              onClick={() => onClick(connectionId)}
            >
              Connect
            </Button>
          </Tooltip>
        ) : null}
      </div>
      <Dialog
        open={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
      >
        <DialogActions>
          <Typography variant="h6" color="text.primary" fontWeight={"bold"}>
            Are you sure you want to forget this device?
          </Typography>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              deleteDevice();
              setShowDeleteDialog(false);
            }}
          >
            Delete
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowDeleteDialog(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}
